
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residents/sign-lease",
      function () {
        return require("private-next-pages/residents/sign-lease/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residents/sign-lease"])
      });
    }
  